import React from 'react'
import Card from '../components/Card'
import { Link } from 'react-router-dom'

export default function HowItWorks() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">How it works</h2>

        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
          <Card><div style={{fontWeight:700}}>1. Create an account</div><div className="kv">Sign up and tell us a bit about yourself or your business.</div></Card>
          <Card><div style={{fontWeight:700}}>2. Find the project support you need</div><div className="kv"><Link to="/directory">Product Offerings</Link></div></Card>
                    <Card><div style={{fontWeight:700}}>3. Chat & collaborate with our team</div><div className="kv">Use in-app messaging to discuss details and ask questions.</div></Card>

          {/* <Card><div style={{fontWeight:700}}>3. Chat and collaborate with our team members</div><div className="kv">Securely upload receipts, statements and invoices.</div></Card> */}
        </div>

        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
          <Card><div style={{fontWeight:700}}>4. Review project details</div><div className="kv">Tell us more about your project and how we can help you. </div></Card>
          <Card><div style={{fontWeight:700}}>5. Sign a Project Support Contract with one of our partners</div><div className="kv">After completing the order intake, one of our partners will contact you to discuss your project and share a draft project agreement. The projeect will commence after the both parties sign the project agreement. </div></Card>
          <Card><div style={{fontWeight:700}}>6. Support service delivery and monitoring</div><div className="kv">Our partners will deliver the contracted services based on the agreed upon timing.</div></Card>
        </div>
      </section>
    </div>
  )
}
